import { render } from "./Drawer.vue?vue&type=template&id=055d7a4c&scoped=true&ts=true"
import script from "./Drawer.vue?vue&type=script&lang=ts"
export * from "./Drawer.vue?vue&type=script&lang=ts"

import "./Drawer.vue?vue&type=style&index=0&id=055d7a4c&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d7a4c"]])

export default __exports__